export function validateHashtag(value, hashtags = [], limit = 30) {
    const pattern = /^#[A-Za-z0-9_]{1,29}$/;

    const hashtag = value.trim();

    if (hashtags.length >= limit) {
        return `The hashtag field must not have more than ${limit} items.`
    }

    if (hashtag.length < 2) {
        return "The hashtag field is required";
    }

    if (hashtag.length > 31) {
        return "The hashtag field must not be greater than 30 characters.";
    }

    const regex = new RegExp(pattern);

    if (!regex.test(hashtag)) {
        return "The hashtag field format is invalid.";
    }

    return false;
}
